export const TEXT_LOCALE = {
    yes: 'Yes',
    no: 'No',
    zoom: 'Edit content in the dialog opened.',
    comments: {
        title: 'Common comments',
        manager: 'Management',
        empty: 'No data.'
    }
};
